const usagesDigital = [
  { tag: "usageDigital1", color: "#52bd97" },
  { tag: "usageDigital2", color: "#a5cb97" },
  { tag: "usageDigital3", color: "#e5db8d" },
  { tag: "usageDigital4", color: "#ffa580" },
  { tag: "usageDigital5", color: "#ff4159" },
  { tag: "usageDigital6", color: "#4d895e" },
  { tag: "usageDigital7", color: "#5a4d35" },
];

export { usagesDigital };
